var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquerk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 74,
    viewBox: "0 0 59 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3999 64.5568C33.3999 65.2053 33.266 65.8141 32.9983 66.3831C32.7347 66.9521 32.3602 67.4437 31.8749 67.8579C31.3896 68.2721 30.8227 68.5817 30.1742 68.7867L29.6094 67.8704C30.1784 67.6863 30.6742 67.4269 31.0967 67.0922C31.5193 66.7533 31.8435 66.3663 32.0695 65.9312C32.2996 65.4919 32.4146 65.0338 32.4146 64.5568V64.0861H33.3999V64.5568ZM33.6007 64.5568C33.6007 65.0003 33.7179 65.427 33.9522 65.8371C34.1865 66.2471 34.517 66.609 34.9438 66.9228C35.3747 67.2324 35.8767 67.4667 36.4499 67.6256L35.8914 68.5607C35.2345 68.3683 34.6593 68.0775 34.1656 67.6884C33.6761 67.2993 33.2974 66.8349 33.0297 66.2952C32.7661 65.7513 32.6343 65.1718 32.6343 64.5568V64.0861H33.6007V64.5568ZM36.0922 64.4878H29.9232V63.5401H36.0922V64.4878ZM33.6133 63.9794H32.4146V62.2285H33.6133V63.9794ZM38.7468 68.9247H37.5607V62.285H38.7468V68.9247ZM38.7468 73.3805H31.3603V69.4644H38.7468V73.3805ZM32.5339 72.414H37.5796V70.4246H32.5339V72.414Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6228 66.1311H20.8027V63.3321H21.7942V70.8316H18.625V63.3321H19.6228V66.1311ZM20.8027 69.8589V67.0661H19.6228V69.8589H20.8027ZM23.5828 66.1311H24.7376V63.3321H25.704V70.8316H22.585V63.3321H23.5828V66.1311ZM24.7376 69.8589V67.0661H23.5828V69.8589H24.7376ZM27.9256 73.5176H26.7897V62.2715H27.9256V73.5176Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0214 28.9253C58.0214 44.9004 45.2183 57.8507 29.4248 57.8507C13.6313 57.8507 0.828125 44.9004 0.828125 28.9253C0.828125 12.9503 13.6313 0 29.4248 0C45.2183 0 58.0214 12.9503 58.0214 28.9253Z",
    fill: "url(#paint0_radial_1326_16642)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3203 20.7076C13.3203 20.5261 13.5951 20.3789 13.9341 20.3789H23.8822C24.2212 20.3789 24.496 20.5261 24.496 20.7076C24.496 20.8891 24.2212 21.0363 23.8822 21.0363H13.9341C13.5951 21.0363 13.3203 20.8891 13.3203 20.7076Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3555 20.7076C34.3555 20.5261 34.6141 20.3789 34.9331 20.3789H44.2961C44.6151 20.3789 44.8738 20.5261 44.8738 20.7076C44.8738 20.8891 44.6151 21.0363 44.2961 21.0363H34.9331C34.6141 21.0363 34.3555 20.8891 34.3555 20.7076Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1815 22.6798C23.1815 23.9505 22.4457 24.9807 21.538 24.9807C20.6303 24.9807 19.8945 23.9505 19.8945 22.6798C19.8945 21.409 20.6303 20.3789 21.538 20.3789C22.4457 20.3789 23.1815 21.409 23.1815 22.6798Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2167 22.6798C44.2167 23.9505 43.4808 24.9807 42.5732 24.9807C41.6655 24.9807 40.9297 23.9505 40.9297 22.6798C40.9297 21.409 41.6655 20.3789 42.5732 20.3789C43.4808 20.3789 44.2167 21.409 44.2167 22.6798Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1092 37.9379C30.1072 37.6103 30.371 37.343 30.6987 37.341L40.1575 37.2811C40.4851 37.279 40.7523 37.5429 40.7544 37.8705C40.7565 38.1981 40.4926 38.4654 40.165 38.4675L30.7062 38.5274C30.3786 38.5294 30.1113 38.2655 30.1092 37.9379Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.039 33.3035C26.2178 33.0289 26.5853 32.9513 26.8598 33.1301C27.9032 33.8095 29.4041 35.1084 30.5754 36.8325C31.7481 38.5586 32.6225 40.7607 32.3062 43.2167C32.2643 43.5416 31.967 43.7711 31.642 43.7292C31.3171 43.6874 31.0876 43.39 31.1295 43.0651C31.3968 40.9894 30.6655 39.0763 29.5941 37.4992C28.5212 35.92 27.1395 34.7279 26.2124 34.1243C25.9379 33.9455 25.8602 33.578 26.039 33.3035Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1326_16642",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.4248 28.9253) rotate(90) scale(28.9253 28.5966)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#FFB1B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEBDC0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquerk);
export default __webpack_public_path__ + "static/media/Squerk.365b37d8eda407392dd755d1758c52a9.svg";
export { ForwardRef as ReactComponent };